import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SearchBox = () => {
    const searchRef = useRef();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const search = searchParams.get('search');

    useEffect(() => {
        if (search) searchRef.current.value = search;
    }, []);
    const formSubmit = async (event) => {
        event.preventDefault();
        navigate('/?search=' + searchRef.current.value);
    };

    return (
        <form onSubmit={formSubmit}>
            <div className='form-control'>
                <input
                    ref={searchRef}
                    className='input input-solid-primary input-sm sm:input-md md:input-lg'
                    placeholder='Search...'
                />
            </div>
        </form>
    );
};

export default SearchBox;
